import { useApolloClient } from '@apollo/client';
import { FormControlLabel, Radio } from '@material-ui/core';
import gql from 'graphql-tag';
import React from 'react';
import { getText } from '../../utils/functions';
import InputFactory from '../inputs/InputFactory';
import FormLabel from './FormLabel';

const classNameCUSTOMS = 'w-full md:pl-8 mt-8 grid grid-flow-row lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10 items-end';
const classNameCUSTOMDIV = 'space-y-10';

function Representatives({
	colors,
	translate,
	setFormData,
	formData,
	portal,
	personType
}) {
	const [representatives, setRepresentatives] = React.useState(null);
	const [loading, setLoading] = React.useState(true);
	const client = useApolloClient();
	const [showForm, setShowForm] = React.useState(false);
	const formType = 'delegation';

	const dinamicInputs = React.useMemo(() => portal?.config?.inputs?.[formType]?.[personType]
		?.filter(input => input.isActive), [portal?.config?.inputs?.[formType]?.[personType]]);

	const inputProps = {
		confirmError: getText(portal?.config?.validation?.confirmError, translate)
	};

	const styleLIST = {
		borderLeft: `2px solid ${colors?.primary}`
	};

	const getData = React.useCallback(async () => {
		const response = await client.query({
			query: gql`
				query CouncilPortalDelegates($councilId: Int!) {
					councilPortalDelegates(councilId: $councilId) {
						id
						name
						surname
						position
					}
				}
			`,
			variables: {
				councilId: portal.council.id
			}
		});

		setRepresentatives(response.data.councilPortalDelegates);
		setLoading(false);
	}, [portal.council.id]);

	React.useEffect(() => {
		getData();
	}, [getData]);

	if (representatives?.length > 0) {
		return (
			<React.Fragment>
				<div
					style={{ marginBottom: '2%' }}
				>
					<FormLabel
						text={`${translate.representative_power}:`}
						colors={colors}
						translate={translate}
						noGetText={true}
						portal={portal}
					/>
				</div>
				<div
					style={{ display: 'flex', flexDirection: 'column', marginBottom: '3%' }}>
					{!loading && representatives.map(represent => (
						<FormControlLabel
							key={`represent_${represent.id}`}
							control={
								<Radio
									name='representative'
									checked={formData.delegate?.id === represent.id}
									onChange={() => {
										const { __typename, ...rest } = represent;
										setShowForm(false);
										setFormData({
											...formData,
											delegate: rest
										});
									}}
									style={{ color: colors.primary }}
								/>
							}
							label={`${translate[`position_${represent?.position?.toLowerCase()}`].toUpperCase()} - ${represent?.name} ${represent?.surname}`}
							style={{ color: colors.text }}
						/>
					))}
					< FormControlLabel
						control={
							<Radio
								name='representative'
								checked={showForm}
								onChange={() => {
									setShowForm(true);
									setFormData({
										...formData,
										delegate: {}
									});
								}}
								style={{ color: colors.primary }}
							/>
						}
						label={translate.another_mutualist}
						style={{ color: colors.text }}
					/>
				</div>
				{showForm &&
					<div>
						<FormLabel
							text={portal?.config?.forms?.delegation}
							colors={colors}
							translate={translate}
						/>

						<div className={classNameCUSTOMDIV}>
							<div className={classNameCUSTOMS} style={styleLIST}>
								{dinamicInputs
									&& dinamicInputs?.map(inputConfig2 => <InputFactory
										portal={portal}
										inputConfig={inputConfig2}
										formData={formData}
										setFormData={setFormData}
										personType={personType}
										value={formData[personType][inputConfig2.name]}
										key={inputConfig2.name}
										colors={colors}
										translate={translate}
										inputProps={inputProps}
									/>)}
							</div>
						</div>
					</div>
				}
			</React.Fragment>
		);
	} return <div>
		<FormLabel
			text={portal?.config?.forms?.delegation}
			colors={colors}
			translate={translate}
		/>

		<div className={classNameCUSTOMDIV}>
			<div className={classNameCUSTOMS} style={styleLIST}>
				{dinamicInputs
					&& dinamicInputs?.map(inputConfig2 => <InputFactory
						portal={portal}
						inputConfig={inputConfig2}
						formData={formData}
						setFormData={setFormData}
						personType={personType}
						value={formData[personType][inputConfig2.name]}
						key={inputConfig2.name}
						colors={colors}
						translate={translate}
						inputProps={inputProps}
					/>)}
			</div>
		</div>
	</div>;
}

export default Representatives;
